<template>
    <div>
      <AiHead></AiHead>
      <AINewBasic></AINewBasic>
      <AiPersonalCenter></AiPersonalCenter>
      <div class="chat">
        <!-- 头部 -->
        <div class="chat-top">
          <!-- 返回首页 -->
          <div class="chat-top__goback">
            <i class="el-icon-arrow-left" @click="goHome" style="font-size: 24px; font-weight: 700;"></i>
          </div>
          <div class="chat-top__image">
            <el-avatar><img :src="aiInfo.headImg"/></el-avatar>
          </div>
          <div class="chat-top__ainame">{{aiInfo.aiName}}</div>
          <!-- 文件列表标签 -->
          <!-- <el-tag
            :key="tag"
            v-for="tag in fileList"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
            @click="showFile(tag)"
            >
            {{tag.fileName}}
          </el-tag> -->
          <!-- 历史记录 -->
          <!-- <el-tooltip effect="light" content="查看历史" placement="bottom">
            <div class="chat-top__detail" @click="detailMethod"><i id="el-icon-s-tools" class="el-icon-s-tools"></i></div>
          </el-tooltip> -->
          <div v-if="aiInfo.userId === loginUserId"  class="chat-top__detail" @click="detailMethod">
            <i id="el-icon-s-tools" class="el-icon-s-tools"></i>
          </div>
        </div>
        <!-- 聊天区域 -->
        <div class="chat-center" ref="chatCenter">
          <div v-for="(chat, index) in chatList" :key="chat.id">
            <!-- 用户聊天记录 -->
            <div v-if="chat.msgType === 10" class="chat-center-item">
              <el-avatar>
                <img  v-if="chat.headImg" :src="chat.headImg"/>
                <div v-else class="chat-center-item__userimg">
                    <span>{{ userNameFirstStr }}</span>
                </div>
              </el-avatar>
              <span class="chat-center-item__span" style="white-space: pre-wrap;">{{ chat.content }}</span>
            </div>
            <!-- AI聊天记录 -->
            <div v-else-if="chat.msgType === 20" class="chat-center-item">
              <el-avatar>
                <img :src="chat.headImg"/>
              </el-avatar>
              <span v-if="!chat.content"  class="chat-center-item__span" style="color: #0810ee; white-space: pre-wrap;">
                {{ replyContent ? replyContent : '. . . ' }}
              </span>
              <span v-else class="chat-center-item__span" style="white-space: pre-wrap;">{{ chat.content }}</span>
            </div>
          </div>
        </div>
        <!-- 底部发送聊天 -->
        <div class="chat-send">
          <!-- 重新开始对话按钮 -->
          <el-tooltip effect="light" content="重新开始对话" placement="bottom">
            <div class="chat-send__refresh" @click="restartMsg"><i id="icon-refresh-left" class="el-icon-refresh-left"></i></div>
          </el-tooltip>
          <!-- 发送输入框 -->
          <el-input class="chat-send__input" type="textarea" v-model="content" :maxlength="200" placeholder="请输入内容"  
          @keyup.enter.native="sendContent" autosize :readonly="disabled" style="min-height: 33px;"></el-input>
          <!-- 上传文件 -->
          <!-- <div class="upload-file">
            <el-upload
                class="file-uploader"
                action="/aigenai/upload/uploadFile"
                :show-file-list="true"
                :on-success="handleFileSuccess"
                :before-upload="beforeFileUpload"
              >
              <i id="el-icon-picture-outline" class="el-icon-picture-outline"></i>
            </el-upload>
          </div> -->
          <!-- 发送按钮 -->
          <div @click="sendContent" class="chat-send__send">
            <el-tooltip effect="light" content="点击发送" placement="bottom">
              <i id="el-icon-position" class="el-icon-position" style="font-size: 28px; transform: rotate(45deg); transform-origin: 20% 40%;"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import AiHead from '../components/AI-Head.vue';
import AINewBasic from '../components/AI-New-Basic.vue'
import AiPersonalCenter from '../components/AI-Personal-Center.vue'
export default {
  name: 'Chat',
  components: {
    AiHead,
    AINewBasic,
    AiPersonalCenter,
  },
data() {
  return {
    disabled: false,
    aiInfo: this.$route.query.aiInfo,
    loginUserId: this.$store.state.user.id || localStorage.getItem('userId'),
    userName: this.$store.state.user.userName || localStorage.getItem('userName'),
    chatList: [],
    // 用户输入内容
    content: '',
    // AI回复内容
    replyContent: '',
    // 上传文件列表
    fileList: [],
    fileObj: '',
  }
},
computed: {
  userNameFirstStr: function(){
    return this.userName ? this.userName.slice(0, 1) : ''
  },
},
mounted(){
  this.getChatList()
  // 暂时注释文件列表
  // this.getFileList()
},
methods: {
  // 返回首页
  goHome() {
    this.$router.push('/home')
  },
  // 展示文件详情
  showFile(tag) {
    this.tag.filePath = process.env.VUE_APP_IMAGE_URL + (res.data.filePath ? res.data.filePath.substr(res.data.filePath.indexOf('/aigenai')) : '')
  },
  // 展示AI详情
  detailMethod(){
    this.$bus.$emit('createAi', true, this.aiInfo.id)
  },
  // 设置欢迎语
  setAiWecomde(){
    if (!this.aiInfo.aiWelcome) {
      return
    }
    // AI消息
    let chatObj = {
      aiId: this.aiInfo.id,
      userId: this.loginUserId,
      msgType: 20,
      headImg: this.aiInfo.headImg,
      content: this.aiInfo.aiWelcome,
    }
      this.chatList.push(chatObj)
  },
  // 获取文件上传列表
  getFileList() {
    // 传入当前AI主键ID，和当前登录用户的主键ID
    this.$http.get('/aigenai/upload/getFileList', {params:{aiId: this.aiInfo.id, userId: this.loginUserId}},
    ).then(
      res => {
        if (res.code !== 0) {return}
        this.fileList = []
        this.fileList.push(...res.data)
      }
    ).catch(err=>{console.log('err', err)})
  },
  // 获取聊天记录
  getChatList(){
    // 传入当前AI主键ID，和当前登录用户的主键ID
    this.$http.get('/aigenai/chat/getChatList', {params:{aiId: this.aiInfo.id, userId: this.loginUserId}},
    ).then(
      res => {
        if (res.code !== 0) {return}
        this.chatList = []
        // 设置欢迎语
        this.setAiWecomde()
        this.chatList.push(...res.data)
        this.toScrollBottom()
      }
    ).catch(err=>{console.log('err', err)})
  },
  handleClose(tag) {
      this.$http.get('/aigenai/upload/deleteFile', {params:{id: tag.id}},
    ).then(
      res => {
        if (res.code !== 0) {return}
      }
    ).catch(err=>{console.log('err', err)})
    this.fileList.splice(this.fileList.indexOf(tag), 1);
  },
  // 上传文件成功之后处理
  handleFileSuccess(res, file) {
    if (res.code === 1) {
      this.$message({message: res.msg, type: 'error'})
      return 
    }
    this.replyContent = res.data.replyContent
    // console.log('fileName => ', file.name)
    // console.log('filePath => ', res.data.filePath)
    // console.log('replyContent => ', res.data.replyContent)
    // this.fileObj.fileName = file.name
    // this.fileObj.filePath = process.env.VUE_APP_IMAGE_URL + (res.data.filePath ? res.data.filePath.substr(res.data.filePath.indexOf('/aigenai')) : '')
    // this.fileList.push(this.fileObj)
    // console.log("fileList => ", this.fileList)
    // 传入当前I主键ID，和当前登录用户的主键ID
    this.$http.post('/aigenai/upload/saveFile', {params:{aiId: this.aiInfo.id, userId: this.loginUserId, fileName: file.name, filePath: res.data.filePath}},
    ).then(
      res => {
        if (res.code !== 0) {return}
      }
    ).catch(err=>{console.log('err', err)})
    this.sendContent()
  },
  // 上传文件之前处理
  beforeFileUpload(file){
        console.log(file.type)
        const isFormat = file.type === 'application/txt'  || file.type === 'application/doc' || file.type === 'application/pdf' || file.type === 'application/ppt' || file.type === 'application/xls';
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isFormat) {
          this.$message.error('文件只能是 txt/doc/pdf/ppt/xls 格式!');
        }
        if (!isLt10M) {
          this.$message.error('文件大小不能超过 10MB!');
        }
        return isFormat && isLt10M;
  },
  // 重新开始对话
  restartMsg() {
    this.$http.post('/aigenai/chat/restartMsg', {aiId: this.aiInfo.id, userId: this.loginUserId}).then(
      res=>{
        if (res.code !== 0) return
        this.chatList = []
        // 设置欢迎语
        this.setAiWecomde()
      }
    ).catch(err=>{console.log('err', err)})
  },
  // 发送消息进行敏感词校验
  sendContent(){
    // if (!this.content.trim() || this.replyContent.trim()) {
    //   this.$message({message: '不能发送空内容', type: 'warning'});
    //   return
    // }
    this.$http.post('/aigenai/user/checkSensitiveWords', {input: this.content}).then(
      res=>{
        if (res.code !== 0) return
        if (res.data) {
          this.$message({message: '输入包含不法词汇，请修改后提交', type: 'warning'});
          return
        }
        // 发送消息操作
        this.sendContentMethod()
      }
    ).catch(err=>{console.log('err', err)})
  },
  /*发送消息操作*/
  sendContentMethod(){
    // 校验敏感词
    this.disabled = true
    // 用户消息
    let chatObj = {
      aiId: this.aiInfo.id,
      userId: this.loginUserId,
      msgType: 10,
      headImg: '',
      content: this.content,
    }
    this.chatList.push(chatObj)
    // 重置用户输入内容
    this.content = ''
    this.replyContent = ''
    // 滚动到底部
    this.toScrollBottom()
    // 保存聊天内容
    this.saveChatMsg(chatObj)
    // 展示回复区域
    this.showReplyRegion()
  },

  /*保存聊天内容*/
  saveChatMsg(chatObj){
    let _this = this
    this.$http.post('/aigenai/chat/add', {...chatObj}).then(
    res => {
      if (res.code !== 0) {
        this.disabled = false
        return
      }
      // 定时器展示给用户信息
      const timer = setInterval(function() {
        // 依次累加显示AI回复内容
        let resData = res.data ? res.data : ['请重新提问，或联系管理员~~~']
        let shiftContent = resData.shift()
        _this.replyContent += shiftContent
        // 粗略估计一行40个字符,或者遇到换行符
        if (_this.replyContent.length % 40 === 0 || shiftContent == '\n') {
          _this.toScrollBottom()
        }
        if (res.data.length <= 0) {
          _this.disabled = false
          // 替换聊天数组中最后一条记录的内容
          _this.chatList.forEach((item, index)=>{
            if (_this.chatList.length - 1 === index) {
              item.content = _this.replyContent
            }
          })
          clearInterval(timer)
        }
      }, 10);
    }).catch(err=>{console.log('err', err)})
  },
  // 展示AI回复区域
  showReplyRegion() {
    let chatObj = {
      aiId: this.aiInfo.id,
      userId: this.loginUserId,
      msgType: 20,
      headImg: this.aiInfo.headImg,
      content: '',
    }
    // 增加一条消息占位
    this.chatList.push(chatObj)
    this.toScrollBottom()
  },
  // 校验输入敏感词
  checkSensitiveWords(){
    
  },
  // 自动滚动到聊天区域底部
  toScrollBottom(){
    this.$nextTick(() => {
      this.$refs.chatCenter.scrollTop = this.$refs.chatCenter.scrollHeight
    });
  }
  },
}
</script>
  
<style lang="less" scoped>
.el-tag + .el-tag {
    margin-left: 10px;
}
.chat{
  position: absolute;
  width: 800px;
  height: 100%;
  top: 100px;
  left: 25%;
}
.chat-top{
  position: relative;
  display: flex;
  flex-direction: row;
  min-height: 5%;
  width: 100%;
  &__goback{
   width: 8%;
   margin-top: 8px;
   cursor: pointer;
   :hover{
      color: #0d16ce;
   }
  }
  &__image{
    width: 5%;
  }
  &__ainame{
    width: 82%;
    font-weight: 800;
    font-size: 20px;
    margin-top: 5px;
    margin-left: 20px;
  }
  &__detail{
    margin: auto 0px;
  }
}
.chat-center {
  margin-top: 15px;
  width: 100%;
  height: 60%; 
  overflow: auto;
  background-color: #d5d3d368;
  .chat-center-item{
    margin: 30px 0 40px 40px;
    display: flex;
    flex-direction: row;
    &__userimg{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #C0C4CC;
      > span {
        margin: auto;
        font-size: 26px;
        color: #3812e2;
      }
    }
    &__span {
      margin: auto 20px;
      width: 600px;
    }
  }
}
.chat-send {
  position: relative;
  min-height: 5%;
  max-width: 800px; 
  margin-top: 10px;
  &__refresh{
    position: absolute;
    left: 0px;
    border-radius: 50%;
    background-color: #0d16ce;
    cursor: pointer;
  }
  &__input{
    width: 95%;
    margin-left: 5%;
  }
  &__send{
    position: absolute;
    top: -2px;
    right: 0;
    margin-left: -30px;
    cursor: pointer;
  }
}
#el-icon-position:hover{
  color: #0810ee;
}
#el-icon-picture-outline:hover{
  color: #0810ee;
}
#icon-refresh-left{
  font-size: 28px; 
  font-weight: 900; 
  color: #fff;
  margin: 3px;
}
#el-icon-s-tools{
  font-size: 30px;
  color: #706c6cd5;
  cursor: pointer;
}
#el-icon-s-tools:hover{
  color: #0d16ce;
}
</style>